import * as React from 'react';

import { $gt } from '@/common/appCtx';

export enum CalculateMethod {
  Min,
  Max,
  Sum,
}

export const CalculateMethodCommonText = (
  <>
    <p
      dangerouslySetInnerHTML={{
        __html: $gt('1.Use the search bar above to {boldText} that need to be displayed in this Group Throughput Overview area.', null, {
          boldText: '<span style="color: #000; font-weight: bold;">filter the Workstation Groups</span>'
        })
      }}
    />
    <p
      dangerouslySetInnerHTML={{
        __html: $gt('2.The following cards show {boldText} processed by the corresponding Workstation Group within last 1 Hour.', null, {
          boldText: '<span style="color: #000; font-weight: bold;">the quantity of orders</span>'
        })
      }}
    />
    <p
      dangerouslySetInnerHTML={{
        __html: $gt('3.Click the TV Mode Button on the right side of this bar to navigate to {boldText}', null, {
          boldText: '<span style="color: #000; font-weight: bold;">a Group Card Carousel TV Mode.</span>'
        })
      }}
    />
    <p
      dangerouslySetInnerHTML={{
        __html: $gt('4.Click the icon in the upper right corner of the Group Card to generate {boldText}', null, {
          boldText: '<span style="color: #000; font-weight: bold;">a TV Mode for only displaying the currently selected Workstation Group.</span>'
        })
      }}
    />
  </>
);

export const CalculateMethodMinText = (
  <>
    {CalculateMethodCommonText}
    <p
      dangerouslySetInnerHTML={{
        __html: $gt('5.{boldText} Sum of orders processed by system-interactive workstations with minimum sequence number in this Workstation Group, during selected period of time.', null, {
          boldText: '<span style="color: #000; font-weight: bold;">Calculation Method for Group\'s Total Throughput:</span>'
        })
      }}
    />
  </>
);

export const CalculateMethodMaxText = (
  <>
    {CalculateMethodCommonText}
    <p
      dangerouslySetInnerHTML={{
        __html: $gt('5.{boldText} Sum of orders processed by system-interactive workstations with maximum sequence number in this Workstation Group, during selected period of time.', null, {
          boldText: '<span style="color: #000; font-weight: bold;">Calculation Method for Group\'s Total Throughput:</span>'
        })
      }}
    />
  </>
);

export const CalculateMethodSumText = (
  <>
    {CalculateMethodCommonText}
    <p
      dangerouslySetInnerHTML={{
        __html: $gt('5.{boldText} Sum of orders processed by system-interactive workstations in this Workstation Group, during selected period of time.', null, {
          boldText: '<span style="color: #000; font-weight: bold;">Calculation Method for Group\'s Total Throughput:</span>'
        })
      }}
    />
  </>
);

export const LastTenHoursGroupThroughputTooltip = (
  <>
    <p
      dangerouslySetInnerHTML={{
        __html: $gt('1.Use the "Comparison Group" field to {boldText} that need to be compared to the currently selected Workstation Group.', null, {
          boldText: '<span style="color: #000; font-weight: bold;">filter the Workstation Groups</span>'
        })
      }}
    />
    <p
      dangerouslySetInnerHTML={{
        __html: $gt('2.The image area shows Groups\' Total Throughput {boldText}', null, {
          boldText: '<span style="color: #000; font-weight: bold;">within last 10 hours</span>'
        })
      }}
    />
    <p
      dangerouslySetInnerHTML={{
        __html: $gt('3.The image area can display a maximum of {boldText} of information simultaneously.', null, {
          boldText: '<span style="color: #000; font-weight: bold;">9 groups</span>'
        })
      }}
    />
  </>
);

export enum MeetTarget {
  OnTarget= 1,
  BelowTarget,
}

export const MeetTargetOptions = [
  {
    get label() {return $gt('On Target');},
    value: MeetTarget.OnTarget
  },
  {
    get label() {return $gt('Below Target');},
    value: MeetTarget.BelowTarget
  }
];

export enum TimeRange {
  Last1Hour,
  Last10Hours,
}

export const OnTargetRateTooltip = (
  <>
    <p
      dangerouslySetInnerHTML={{
        __html: $gt('1.This "On Target Rate" tab shows {boldText}', null, {
          boldText: '<span style="color: #000; font-weight: bold;">the on target status of all Workstations within the selected Workstation Group during the last 10 hours.</span>'
        })
      }}
    />
    <p
      dangerouslySetInnerHTML={{
        __html: $gt('2.{boldText} The quantity of on target Workstations / The quantity of all Workstations within the selected Workstation Group.', null, {
          boldText: '<span style="color: #000; font-weight: bold;">Calculation Method for On Target Rate:</span>'
        })
      }}
    />
  </>
);

export enum WorkstationPerformanceType {
  Throughput,
  OnTargetRate,
}

export const LOOP_TIME = 1000 * 60;

export const MAX_WORKSTATION_PER_PAGE = 4;

export const VISIBLE_GROUPS = 4; // 默认显示的 group 数量

export const HIGH_COUNT = 9999999;

export const SorterEnum = {
  none: 0,
  hourly_productivity_asc: 10,
  hourly_productivity_desc: 11,
  manhour_asc: 20,
  manhour_desc: 21,
  target_asc: 30,
  target_desc: 31,
};

export const MAX_SELECTED_WORKSTATION = 9;

export const REQUEST_INTERVAL = 1000 * 60 * 5; // 5 minutes

export const CACHE_KEY = 'workstation-dashboard-cache-key';

export enum CacheType {
  GroupThroughputOverview,
  Last10HoursGroupThroughput,
  WorkstationPerformanceLast1Hour,
  WorkstationPerformanceLast10Hours,
  OperatorPerformanceLast1Hour,
  OperatorPerformanceLast10Hours,
  TimeRange,
  ChartType,
}

export const DEFAULT_PAGE_SIZE = 24;
